import React, { useState } from "react";
import LoadingSpinner from "../../../../components/Loadder";
import { postData, getData } from "../../../../serverRequest";
import { toast, ToastContainer } from 'react-toastify';


export default function ProductForm(props) {
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [serialNumber, setSerialNumber] = useState('');
  const [oem, setOem] = useState('');
  const [modelNumber, setModelNumber] = useState('');
  const [brandName, setBrandName] = useState('');
  const [productType, setProductType] = useState('');
  const [vendor, setVendor] = useState('');
  const [entityName, setEntityName] = useState('');
  const [totalEntities, setTotalEntities] = React.useState([]);
  const filterEntityData = (entities_data) => {
    //console.log(tickets_data);
    let totalEntity = [];
    if (entities_data) {
      for (let i = 0; i < entities_data.length; i++) {
        totalEntity.push(entities_data[i])
      }
    }

    setTotalEntities(totalEntity);
    return ({ "total": totalEntity })
  }
  React.useEffect(() => {
    async function fetchData() {
      let resData = await getData('/api/company?admin=1')
      let entities_data = resData['data']['entities']
      console.log(entities_data);
      let entitiesData = await filterEntityData(entities_data)


      setLoading(false);
    }
    fetchData();


  }, [])

  const handleSubmit = async (event) => {
    event.preventDefault();


    setLoading(true);

    const formData = {
      'serial_number': serialNumber,
      'oem': oem,
      'model_number': modelNumber,
      'brand_name': brandName,
      'product_type': productType,
      'vendor': vendor,
      'entity_name': entityName,
    };
    console.log(formData);

    try {
      const resData = await postData("/api/product/bizproduct/", formData);
      console.log(resData);
      
      if (resData['data']['code'] === 200) {
        setLoading(false);
        setShowModal(true);
        toast.success("Product added successfully")
        window.location.href = "/admin/inventory/products";
      } else {
        console.error("Failed to submit form:", resData.statusText);
        setLoading(false);
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      setLoading(false);
    }
  };

  return (
    <div className="product-form-container p-4 min-h-screen w-full">
      {loading ? (
        <LoadingSpinner></LoadingSpinner>
      ) : (
        <form onSubmit={handleSubmit}>
          <div className="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded-lg bg-blueGray-100 border-0">
            <div className="rounded-t bg-white mb-6 px-6 py-6">
              <div className="text-center flex justify-between">
                <h6 className="text-blueGray-700 text-xl font-bold">Product Form</h6>
              </div>
            </div>
            <div className="flex flex-wrap justify-between">
              <div className="w-full lg:w-4/12 px-4">
                <div className="relative w-full mb-3">
                  <label className="block uppercase text-blueGray-600 text-xs font-bold mb-2" htmlFor="entityName">
                    Entity Name
                  </label>
                  <select
                    className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                    name="entityName"
                    value={entityName}
                    onChange={(e) => setEntityName(e.target.value)}
                  >
                    {totalEntities.map((entity, index) => (
                      <option key={index} value={entity.company_code}>
                        {entity.name}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
              <div className="w-full lg:w-4/12 px-4">
                <div className="relative w-full mb-3">
                  <label className="block uppercase text-blueGray-600 text-xs font-bold mb-2" htmlFor="serialNumber">
                    Serial Number
                  </label>
                  <input
                    type="text"
                    className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                    name="serial_number" value={serialNumber} onChange={(e) => setSerialNumber(e.target.value)} />
                </div>
              </div>
              <div className="w-full lg:w-4/12 px-4">
                <div className="relative w-full mb-3">
                  <label className="block uppercase text-blueGray-600 text-xs font-bold mb-2" htmlFor="oem">
                    OEM
                  </label>
                  <input
                    type="text"
                    className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                    name="oem" value={oem} onChange={(e) => setOem(e.target.value)} />
                </div>
              </div>
              <div className="w-full lg:w-4/12 px-4">
                <div className="relative w-full mb-3">
                  <label className="block uppercase text-blueGray-600 text-xs font-bold mb-2" htmlFor="modelNumber">
                    Model Number
                  </label>
                  <input
                    type="text"
                    className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                    name="model_number" value={modelNumber} onChange={(e) => setModelNumber(e.target.value)} />
                </div>
              </div>
              <div className="w-full lg:w-4/12 px-4">
                <div className="relative w-full mb-3">
                  <label className="block uppercase text-blueGray-600 text-xs font-bold mb-2" htmlFor="brandName">
                    Brand Name
                  </label>
                  <input
                    type="text"
                    className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                    name="brand_name" value={brandName} onChange={(e) => setBrandName(e.target.value)} />
                </div>
              </div>
              <div className="w-full lg:w-4/12 px-4">
                <div className="relative w-full mb-3">
                  <label className="block uppercase text-blueGray-600 text-xs font-bold mb-2" htmlFor="productType">
                    Product Type
                  </label>
                  <input
                    type="text"
                    className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                    name="product_type" value={productType} onChange={(e) => setProductType(e.target.value)} />
                </div>
              </div>
              <div className="w-full lg:w-4/12 px-4">
                <div className="relative w-full mb-3">
                  <label className="block uppercase text-blueGray-600 text-xs font-bold mb-2" htmlFor="vendor">
                    Vendor
                  </label>
                  <input
                    type="text"
                    className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                    name="vendor" value={vendor} onChange={(e) => setVendor(e.target.value)} />
                </div>
              </div>
            </div>
            <div className="text-center mt-6 lg:w-3/12 px-4">
              <input
                className="bg-blueGray-800 text-white active:bg-blueGray-600 text-sm font-bold uppercase px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-4 w-full ease-linear transition-all duration-150"
                type="Submit"
                value="Submit"
              />
            </div>
          </div>
        </form>
      )}
      <ToastContainer />
    </div>
  );
}
